import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
} from "@mui/material";

export default function DevGuide() {
  const [guide, setGuide] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/dev-guide")
      .then((res) => res.json())
      .then((data) => {
        setGuide(data.guide);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch dev guide", err);
        setLoading(false);
      });
  }, []);

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Developer Instruction Sheet
      </Typography>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <pre style={{ whiteSpace: "pre-wrap", fontSize: 14 }}>{guide}</pre>
      )}
    </Paper>
  );
}
